



import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaPencil,
  FaAngleLeft,
  FaAngleRight,
  FaDownload,
} from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { downloadApplicationPdf } from "../Utility/downloadRegistrationPdf";
import { viewExperienceDocument } from "../utils/ExperienceDocumentField";
const AdminApplicationView = () => {
    const navigate = useNavigate();
  const dispatch = useDispatch();
const location = useLocation();

  const appId = location.state?.appId;
  const [data, setData] = useState(null);


  const [formData, setFormData] = useState({
    forceNumber: "",
    forceName:"",
    service:"",
    type:"",
    rank:"",
    fullName: "",
    medicalCategory: "",
    dischargeDate: "",
    dischargeBookNo: "",
    unitRetired: "",
    fatherName: "",
    motherName: "",
    dob: "",
    spouseName: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    address: "",
    pinCode: "",
    email: "",
    mobile: "",
    altMobile: "",
    otp: "",
    id:"",
    action:"",
    remarks:""
  });

  const [dischargeFile, setDischargeFile] = useState(null);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [forces, setForces] = useState([]);
  const [services, setServices] = useState([]);
  const [types, setTypes] = useState([]);
  const [ranks, setRanks] = useState([]);
const [pdfSrc, setPdfSrc] = useState(null);
const [showModal, setShowModal] = useState(false);
const [documentModalTitle, setDocumentModalTitle] = useState("Document");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState("");

  const formatFieldLabel = (key) => {
    if (key === 'appStatus') return 'Application Status'
    if (key === 'pppId') return 'PPP Id'
    if (key === 'sasDistrict') return 'District Sainik and Ardh Sainik Welfare Office'
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
  }

  const formatLicenseTypes = (licenses) => {
    if (!Array.isArray(licenses) || licenses.length === 0) return 'N/A'
    const labels = licenses
      .map((license) => (typeof license === 'string' ? license : license?.licenseType))
      .filter((type) => type && String(type).trim())
    return labels.length > 0 ? labels.join(', ') : 'N/A'
  }

  const formatValue = (key, value) => {
    if (value === null || value === undefined) return 'N/A'
    // Handle all date fields with consistent dd/mm/yyyy format
    if ((key.includes('Date') || key === 'dob') && value) return formatDate(value)
    if (key === 'totalAnnualFamilyIncome' && value) return `Rs. ${value.toLocaleString()}`
    if (key === 'appStatus' && value) {
      return <span className={`text-secondary fw-bold`}>{value}</span>
    }
    if (key === 'licenses') return formatLicenseTypes(value)
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    if (value === 'Y' || value === 'y') return 'Yes'
    if (value === 'N' || value === 'n') return 'No'
    if (value === 'Yes' || value === 'No') return value
    if (Array.isArray(value)) {
      return value
        .map((item) => (item && typeof item === 'object' ? JSON.stringify(item) : item))
        .join(', ')
    }
    if (typeof value === 'object') return 'N/A'
    return value
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const importantFields = [
    'appStatus', 'pppId', 'memberId', 'forceNumber', 'forceName', 'fullName',
    'service', 'type', 'rank', 'gender', 'dob', 'mobile', 'email',
    'sasDistrict', 'state', 'district', 'tehsil', 'village', 'address', 'pinCode',
    'totalAnnualFamilyIncome'
  ]

   const hiddenFields = [
    'id', 'editAllowed', 'actionAllowed', 'experience', 'licenses','spouseName','stateCode','districtCode','tehsilCode','sasDistrictCode','highestQualificationId','casteCategoryId','currentEngagementId','documents','nokDetails','verificationStatus'
  ]

  const otherFields = data
    ? Object.keys(data).filter(key => !importantFields.includes(key) && !hiddenFields.includes(key))
    : [];


  const fetchData = async () => {
      if (!appId) {
        navigate("/dashboard/registration-data");
        return;
      }

      dispatch(isloading());
      try {
        const res = await AxiosInstance.get(
          `${BaseUrl}/api/admin/view-capf-application/${appId}`
        );
        const application = res.data?.data;

        if (!application) {
          toast.error("Application not found");
          navigate("/dashboard/registration-data");
          return;
        }

        setData(application);
        setFormData((prev) => ({
          ...prev,
          ...application,
          action: "",
          remarks: "",
        }));
        setDistricts([application.district]);
        setStates([application.state]);
        setTehsils([application.tehsil]);
        setForces([application.forceName]);
        setServices([application.service]);
        setTypes([application.type]);
        setRanks([application.rank]);
      } catch (error) {
        handleAxiosError(error);
        navigate("/dashboard/registration-data");
      } finally {
        dispatch(isloading());
      }
    };
 useEffect(() => {
     fetchData();
  }, [appId]);


  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "action" && value === "approve") {
    setFormData(prev => ({
      ...prev,
      action: value,
      remarks: "" 
    }));
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};

  const handleStateChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, state: value, district: "" }));
  };

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
  const maxSizeInBytes = 1 * 1024 * 1024;

  if (!allowedTypes.includes(file.type)) {
    toast.error("Invalid file type. Only PDF, PNG, and JPG are allowed.");
    e.target.value = ""; 
    return;
  }

  if (file.size > maxSizeInBytes) {
    toast.error("File size should not exceed 1MB.");
    e.target.value = ""; 
    return;
  }

  setDischargeFile(file); 
};


  const handleSubmit = async () => {
dispatch(isloading());
    try {
      const registerRes = await AxiosInstance.post(
        `${BaseUrl}/api/admin/action-registration`,
        {status: formData.action ==="approve" ? "APPROVED":"REJECTED",
            remarks:formData.remarks,
            appId:formData.id
        ,
        }
      );

      if (registerRes.data?.status === 200) {
       toast.success(registerRes.data.message);
       navigate("/dashboard/registration-data")
      } else {
        toast.error(registerRes.data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Registration failed");
    } finally {
      dispatch(isloading());
    }
  };

 const viewDocument=async(docId)=>{
     try {
        dispatch(isloading());
        const res = await AxiosInstance.get(`${BaseUrl}/api/auth/document/${docId}`,
           {
          headers: { 'Content-Type': 'application/json' },
           responseType: 'arraybuffer', 
        });

         const blob = new Blob([res.data], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    setDocumentModalTitle("Discharge/Retirement Book");
    setPdfSrc(pdfUrl); 
    setShowModal(true); 
        
    } catch (err) {
      toast.error(err.response?.data?.message || "Server error");
    } finally {
      dispatch(isloading());
    }
  }

  const viewExperienceDoc = async (docId, fileName) => {
    try {
      dispatch(isloading());
      const objectUrl = await viewExperienceDocument(docId);
      setDocumentModalTitle(fileName || "Experience Document");
      setPdfSrc(objectUrl);
      setShowModal(true);
    } catch (err) {
      toast.error(err.response?.data?.message || "Unable to view experience document");
    } finally {
      dispatch(isloading());
    }
  };
  if (!data) {
    return null;
  }

  return (
    <div className="container">
      <div className="card shadow-lg">
        <div className="card-header text-white d-flex align-items-center" style={{background:"#008d96"}}>
          <h4 className="mb-0 text-start flex-grow-1">Application Details - CAPF</h4>
          <button
            type="button"
            className="btn btn-light btn-sm ms-auto w-25"
            onClick={() => downloadApplicationPdf(appId, "admin")}
          >
          < FaDownload /> Download Application
          </button>
        </div>
        <div className="card-body">
          
          {/* Important Information Section */}
          <div className="row mb-4">
            <div className="col-12">
              <h5 className="text-primary mb-3">Basic Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    {importantFields.map(key => (
                      <tr key={key}>
                        <th className="bg-light" style={{ width: '30%' }}>
                          {formatFieldLabel(key)}
                        </th>
                        <td>{formatValue(key, data[key])}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div className="row">
            <div className="col-12">
              <h5 className="text-primary mb-3">Additional Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    
                    {otherFields.map(key => (
                      <tr key={key}>
                        <th className="bg-light" style={{ width: '30%' }}>
                          {formatFieldLabel(key)}
                        </th>
                        <td>{formatValue(key, data[key])}</td>
                      </tr>
                    ))}
                    {data.hasLicense === 'Yes' && data.licenses?.length > 0 && (
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>
                          License Types
                        </th>
                        <td>{formatLicenseTypes(data.licenses)}</td>
                      </tr>
                    )}
                     {data.documents && data.documents.map((doc, index) => (
                    <tr key={index}>
                      <th className="bg-light" style={{ width: '30%' }}>
                        {doc.docName}
                      </th>
                      <td>
                        <button type="button" className="btn btn-primary" style={{ width: '40%' }} onClick={() => viewDocument(doc.docId)}>View</button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
{data.hasNok === "Yes" && data.nokDetails && (
            <div className="row mt-4">
              <div className="col-12">
                <h5 className="text-primary mb-3">NOK Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>NOK Name</th>
                        <td>{data.nokDetails.nokName || 'N/A'}</td>
                      </tr>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>Relation</th>
                        <td>{data.nokDetails.relation || 'N/A'}</td>
                      </tr>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>Age</th>
                        <td>{data.nokDetails.age || 'N/A'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          {/* Experience Section */}
          {data.experience && data.experience.length > 0 && (
            <div className="row mt-4">
              <div className="col-12">
                <h5 className="text-primary mb-3">Experience Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>Sr. No.</th>
                        <th>Experience Type</th>
                        <th>Designation</th>
                        <th>Agency Name</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>PF </th>
                        <th>PF Number</th>
                        <th>ESI</th>
                        <th>ESI Number</th>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.experience.map((exp, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{exp.experienceType || 'N/A'}</td>
                          <td>{exp.designation || 'N/A'}</td>
                          <td>{exp.agencyName || 'N/A'}</td>
                          <td>{exp.fromDate ? formatDate(exp.fromDate) : 'N/A'}</td>
                          <td>{exp.toDate ? formatDate(exp.toDate) : 'N/A'}</td>
                          <td>{exp.pf }</td>
                          <td>{exp.pfNumber || 'N/A'}</td>
                          <td>{exp.esi }</td>
                          <td>{exp.esiNumber || 'N/A'}</td>
                          <td>
                            {exp.experienceType === 'PRIVATE' && exp.docId ? (
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => viewExperienceDoc(exp.docId, exp.docFileName)}
                              >
                                View 
                              </button>
                            ) : (
                              'N/A'
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Action Section */}
          {data?.actionAllowed && (
          <div className="row mt-4">
            <div className="col-12">
              <h5 className="text-primary mb-3">Review Action</h5>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="approve"
                      name="action"
                      value="approve"
                      checked={formData.action === "approve"}
                      onChange={handleChange}
                      required
                    />
                    <label className="form-check-label" htmlFor="approve">Approve</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="reject"
                      name="action"
                      value="reject"
                      checked={formData.action === "reject"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="reject">Reject</label>
                  </div>
                </div>
              </div>
              
              {formData.action === "reject" && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      value={formData.remarks || ""}
                      onChange={handleChange}
                      placeholder="Enter reason for rejection"
                      required
                    />
                  </div>
                </div>
              )}
              
              {formData.action && (
                <div className="row">
                  <div className="col-md-2 mb-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={!formData.action} 
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          )}

        </div>
      </div>

      <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="xl">
        <ModalHeader toggle={() => setShowModal(false)}>{documentModalTitle}</ModalHeader>
        <ModalBody style={{ height: "80vh", padding: 0 }}>
          {pdfSrc && (
            <iframe
              src={pdfSrc}
              title={documentModalTitle}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </ModalBody>
      </Modal>

    </div>
  );
};

export default AdminApplicationView;
